import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { UserNoPassword } from 'types';

export const getUsers = async (): Promise<UserNoPassword[]> => {
  const { data } = await axios.get(`/api/users`);
  return data as UserNoPassword[];
};

type QueryFnType = typeof getUsers;

type UseUsersOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useUsers = ({ config }: UseUsersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['users'],
    queryFn: getUsers,
    ...config,
  });
};
